import { PortalViewId } from './portalViewIds';
import type { ViewConfiguration } from './types';

export const staffMemberViewConfiguration: ViewConfiguration = {
  viewIds: [PortalViewId.PropertiesList],
};
